import React, { useEffect, useState } from "react";
import { CampaignViewDetailsViewCampaignsInfoProps } from "./campaign-view-details-view-campaigns-info.props";
import "./campaign-view-details-view-campaigns-info.scss";
import AddLeadList from "./add-lead-modal/add-lead-list";
import CloseIcon from "@mui/icons-material/Close";
import { getCampaignDetails } from "../../../../../../api/campaign";
import { IconButton } from "@mui/material";
import DataTable from "../campaign-view-details-view-activities-info/task-table/task-table";
import CrossIcon from "../../../../../../assets/icons/cross-icon.svg";
import ConfirmInfo from "../../../../../../assets/icons/confirm-info.svg";
import {
  deleteCampaignAssign,
  editCampaignStatus,
} from "../../../../../../api/lead";
import { ConfirmationPopup } from "../../../../../../common/components";
import { Checkbox } from "@mui/material";
import StatusDialog from "./status-dialog/update-status-dialog";
import AddToCampaignModal from "../../../../../leads/lead-actions/add-new-campaign/add-new-campiagn";
import { useLogin } from "../../../../../../common/hooks/useUser";
import NewEmailTemplateEditor from "../../../../../surveys/email-templates/new-email-template-editor/new-email-template-editor";

const CampaignViewDetailsViewLeadsInfo: React.FC<
  CampaignViewDetailsViewCampaignsInfoProps
> = (props: any) => {
  const {
    allCampaignData,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    permissions,
  } = props;
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const [campiagnDetails, setCampaignDetails] = useState<any>(null);
  const [campiagnName, setCampiagnName] = useState("");
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedLeadIds, setSelectedLeadIds] = useState<number[]>([]);
  const [campaignToDelete, setCampaignToDelete] = useState<{
    leadId: number;
    associationId: number;
    leadName: string;
  } | null>(null);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusFilter, setStatusFilter] = useState("Planned");
  const [selectedAssociationIds, setSelectedAssociationIds] = useState<
    number[]
  >([]);
  const { tenantDetails, userDetails } = useLogin();
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsLeadModalOpen(false);
  };
  const handleSaveStatus = async () => {
    if (selectedLeadIds.length === 0) return;
    setLoading(true);
    try {
      await editCampaignStatus(
        statusFilter,
        selectedAssociationIds,
        "Lead Details"
      );
      setAlertMessage("Campaign Status Updated Successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCampaignDetails();
      setSelectedLeadIds([]); // Clear selection after update
    } catch (error) {
      setAlertMessage("Failed to update campaign status.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setOpenStatusDialog(false);
    }
  };
  const isLeadActionEnabled = (lead: any) => {
    return (
      tenantDetails?.tenantType === "SuperTenant" &&
      lead?.assigned_to &&
      !(lead?.lead_status === "Closed-Lost")
    );
  };

  const confirmDeleteCampaign = async () => {
    if (!campaignToDelete) return;
    setLoading(true);
    try {
      await deleteCampaignAssign(
        campaignToDelete.leadId,
        campaignToDelete.associationId,
        "Lead Details"
      );
      setAlertMessage("Campaign unassigned successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCampaignDetails();
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to unassign campaign."
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
      setIsArchivePopupOpen(false);
      setCampaignToDelete(null);
    }
  };
  const fetchCampaignDetails = async () => {
    setLoading(true);
    try {
      const response = await getCampaignDetails(allCampaignData);
      const campaignData = response?.data?.data;
      setSelectedLeadIds([]);
      setSelectedAssociationIds([]);
      setCampiagnName(campaignData?.name);
      setCampaignDetails(
        (response?.data?.data?.CampaignLeadAssociation || []).map(
          (item: any) => ({
            ...item.lead,
            membership_status: item.lead_status_in_campaign,
            campaign_lead_association_id: item.id,
          })
        )
      );
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCampaignDetails();
  }, [allCampaignData, isLeadModalOpen]);
  const leadColumns = [
    {
      key: "leadName",
      label: "Lead Name",
      render: (lead: any) =>
        `${lead.first_name} ${lead.middle_name || ""} ${lead.last_name || ""}`,
    },
    {
      key: "email",
      label: "Email",
      render: (lead: any) => lead.primary_email_address || "-",
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      render: (lead: any) => lead.primary_phone_number || "-",
    },
    {
      key: "source",
      label: "Lead Source",
      render: (lead: any) => lead.lead_source || "-",
    },
    {
      key: "status",
      label: "Lead Status",
      render: (lead: any) => lead.lead_status || "-",
    },
    {
      key: "membership",
      label: "Member Status",
      render: (lead: any) => lead.membership_status || "-",
    },
  ];
  return (
    <div className="campaign-view-details-view-campaigns-info">
      <div className="campaign-view-details-view-campaigns-info-header">
        <div className="campaign-view-details-view-campaigns-info-header-text">
          Leads
        </div>
        <div>
          {selectedLeadIds.length > 0 ? (
            <div className="action-bar">
              <button
                className="campaign-view-details-view-campaigns-info-header-button"
                onClick={() => setIsCampaignModalOpen(true)}
              >
                Campaigns
              </button>

              <button
                className="campaign-view-details-view-campaigns-info-header-button"
                onClick={() => {
                  setOpenStatusDialog(true);
                }}
              >
                Update Member Status
              </button>
            </div>
          ) : (
            <button
              className="campaign-view-details-view-campaigns-info-header-button"
              onClick={() => setIsLeadModalOpen(true)}
            >
              Add Leads
            </button>
          )}
        </div>
      </div>

      {campiagnDetails && campiagnDetails.length > 0 ? (
        <div className="campaign-leads-table">
          <DataTable
            key={JSON.stringify(selectedLeadIds)}
            columns={leadColumns}
            data={campiagnDetails}
            rowActions={(lead) => {
              const enabled = isLeadActionEnabled(lead);
              return (
                <div
                  style={{ display: "flex" }}
                  className={`${!permissions?.canWrite ? "Mui-disabled" : ""}`}
                >
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setCampaignToDelete({
                        leadId: lead?.id,
                        associationId: lead?.campaign_lead_association_id,
                        leadName: `${lead.first_name} ${lead.middle_name || ""} ${lead.last_name}`,
                      });
                      setIsArchivePopupOpen(true);
                    }}
                    className="icon-button"
                    disabled={!permissions?.canWrite || enabled}
                  >
                    <img src={CrossIcon} alt="done" className="img-icon" />
                  </IconButton>
                  <Checkbox
                    size="small"
                    color="primary"
                    checked={selectedLeadIds.includes(lead.id)}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setSelectedLeadIds((prev) =>
                        isChecked
                          ? [...prev, lead.id]
                          : prev.filter((id) => id !== lead.id)
                      );
                      setSelectedAssociationIds((prev) =>
                        isChecked
                          ? [...prev, lead.campaign_lead_association_id]
                          : prev.filter(
                              (id) => id !== lead.campaign_lead_association_id
                            )
                      );
                    }}
                    disabled={!permissions?.canWrite || enabled}
                  />
                </div>
              );
            }}
          />
        </div>
      ) : (
        <div className="campaign-view-details-view-campaigns-info-no-data">
          No records found.
        </div>
      )}
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setCampaignToDelete(null);
          }}
          onOkay={confirmDeleteCampaign}
          title="Unassign lead"
          note={`Unassign ${campaignToDelete?.leadName} from ${campiagnName} Campaign`}
          buttonText="Confirm"
          Icon={ConfirmInfo}
          className="mark-completed-confirmation"
        />
      </div>
      <StatusDialog
        open={openStatusDialog}
        onClose={() => setOpenStatusDialog(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        handleSaveStatus={handleSaveStatus}
      />
      <AddToCampaignModal
        leadsIds={Object.values(selectedLeadIds).flat() || []}
        isOpen={isCampaignModalOpen}
        setMenuItems={() => {}}
        selectedActions={"addToCampaign"}
        handleMassActionMenuClose={() => setIsCampaignModalOpen(false)}
        onSave={async () => {
          setSelectedLeadIds([]);
          setSelectedAssociationIds([]);
          await fetchCampaignDetails();
          setIsCampaignModalOpen(false);
        }}
        hideAddCampaignButton={true}
        campaignsSection={true}
      />
      {isLeadModalOpen && (
        <div className="modal-overlay">
          <button className="close-button" onClick={handleCloseModal}>
            <CloseIcon sx={{ fontSize: "15px" }} />
          </button>
          <div className="modal-content">
            <AddLeadList
              allCampaignData={allCampaignData}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              handleCloseModal={handleCloseModal}
              campaignName={campiagnName}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignViewDetailsViewLeadsInfo;
